import type {
  ClearRoomTypeElectricalTable,
  GeneratedElectricalGroup,
} from "building-types/electrical/generatedElectricalTypes";
import type { ElectricalLayoutHandle, ElectricalRuleHandle } from "building-types/handles/docEntityHandleTypes";

export interface ElectricalGroupsByRoomOrDocResults {
  electricalGroups: GeneratedElectricalGroup[];
  clearRoomTypeElectrical: ClearRoomTypeElectricalTable;
}

export function embedHandleInElectricalGroups(
  electricalGroup: GeneratedElectricalGroup[],
  handle: ElectricalLayoutHandle | ElectricalRuleHandle,
  handleForLinks?: ElectricalLayoutHandle | ElectricalRuleHandle,
) {
  for (const group of electricalGroup) {
    if (handleForLinks) {
      group.handleForLinks = handleForLinks;
    }
    for (const load of group.loads) {
      load.handle = handle;
    }

    for (const controller of group.controllers) {
      controller.handle = handle;
    }
  }
}
